<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M20 2.25191L2.48736 19.5776C2.2142 19.848 1.84366 19.9999 1.45726 20C1.07086 20.0001 0.700255 19.8483 0.426965 19.5781C0.153675 19.3078 8.97705e-05 18.9412 -1.28783e-06 18.5589C-9.23462e-05 18.1766 0.153319 17.8099 0.42648 17.5395L4.89108 13.1233L1.45789 9.72564L5.45923 5.76681L2.91469 5.76681C2.65711 5.76681 2.41008 5.66558 2.22795 5.48537C2.04581 5.30517 1.94349 5.06077 1.94349 4.80593C1.94349 4.55109 2.04581 4.30668 2.22795 4.12648C2.41008 3.94628 2.65711 3.84505 2.91469 3.84505L6.79948 3.84505C7.04702 3.84478 7.28511 3.751 7.46511 3.58287C7.64511 3.41475 7.75342 3.18497 7.76793 2.94048C7.78244 2.69599 7.70204 2.45525 7.54316 2.26744C7.38428 2.07963 7.15892 1.95894 6.91311 1.93001L6.79948 1.92328L5.82828 1.92328C5.5707 1.92328 5.32368 1.82205 5.14154 1.64185C4.95941 1.46165 4.85708 1.21724 4.85708 0.962401C4.85708 0.707559 4.95941 0.463155 5.14154 0.282955C5.32368 0.102754 5.5707 0.00151883 5.82828 0.00151884L14.3612 0.00151921C16.3882 -0.0383974 18.3502 0.709512 19.8262 2.08471L20 2.25191Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "Damage",
};
</script>

<style scoped></style>
